import React, { ReactElement } from 'react';
import SelectionInput, { TSelectionInputBadge } from './SelectionInput';
import { Radio as componentName } from './name';
import { TAsset, TIcon } from '../../types/TStyleVariables';

export type TRadio = {
  /** value of the checkbox dom input*/
  value: string;
  /** The id of the radio input, also used on the label as htmlFor */
  id?: string;
  /** Whether or not it is checked */
  isChecked: boolean;
  /** The label text. Also passed into aria-label attribute on the input itself*/
  labelText?: string;
  // ** Count of items in a formatted string */
  counter?: string;
  /** Only visible on mobile + stacked */
  icon?: TIcon;
  /** Secondary text below the label. Accepts a string or ReactNode to support inline links. */
  helperText?: React.ReactNode;
  /** On component change */
  onChange?: (evt?: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  name?: string;
  disabled?: boolean;
  /**
   * Deprecated — use `badge` instead.
   * @deprecated
   */
  badgeLabel?: string;
  /** Optional badge. Defaults to `info` signal when no `signal` is provided. */
  badge?: TSelectionInputBadge;
  assetName?: TAsset;
  assetSize?: 'm' | 'l';
  /** Optional price text to display */
  price?: string;
  /** Optional slashed (original) price to display alongside price */
  slashedPrice?: string;
  /** Optional children to render below the main content */
  children?: React.ReactNode;
} & React.HTMLAttributes<any>;

const Radio = ({
  value,
  id,
  name,
  labelText,
  counter,
  icon,
  helperText,
  onChange,
  isChecked,
  badgeLabel,
  badge,
  assetName,
  assetSize,
  price,
  slashedPrice,
  children,
  ...rest
}: TRadio): ReactElement => (
  <SelectionInput
    isChecked={isChecked}
    value={value}
    labelText={labelText}
    counter={counter}
    componentName={componentName}
    icon={icon}
    onChange={onChange}
    id={id}
    helperText={helperText}
    name={name ? name : id}
    badge={badge ?? (badgeLabel ? { label: badgeLabel } : undefined)}
    assetName={assetName}
    assetSize={assetSize}
    price={price}
    slashedPrice={slashedPrice}
    children={children}
    {...rest}
  />
);

export default Radio;
